import type { LocationGenerics } from "@/router/locationGenerics";
import { getAccountContext } from "@/router";

import { ConnectionsDocument } from "@/apollo/types";
import { ConnectionBreadcrumb } from "@/components/elements/breadcrumbs/ConnectionBreadcrumb";
import { ApolloClient } from "@apollo/client";
import { Route } from "@tanstack/react-location";

import { ConnectionsPage } from "./ConnectionsPage";
import ViewConnectionPage from "./ViewConnection";
import { ViewConnectionLayout } from "./ViewConnectionLayout";
import { EditConnectionPage } from "@/pages/Connections/EditConnection";
import { AuthorizeMethod } from "@/pages/Connections/ConnectionForm/ConnectionForm";

export const connectionsRoute = (
  client: ApolloClient<object>,
): Route<LocationGenerics> => {
  return {
    path: "connections",
    meta: {
      breadcrumb: () => "Connections",
    },
    children: [
      {
        path: ":connectionId",
        meta: {
          breadcrumb: ({ connectionId }) => (
            <ConnectionBreadcrumb connectionId={connectionId} />
          ),
        },
        element: <ViewConnectionLayout />,
        children: [
          {
            path: "configuration",
            element: (
              <EditConnectionPage authorizeMethods={[AuthorizeMethod.Self]} />
            ),
            meta: {
              breadcrumb: () => "Configuration",
            },
          },
          {
            path: "authorization-link",
            element: (
              <EditConnectionPage
                authorizeMethods={[AuthorizeMethod.External]}
              />
            ),
            meta: {
              breadcrumb: () => "Authorization Link",
            },
          },
          {
            element: <ViewConnectionPage />,
          },
        ],
      },
      {
        element: <ConnectionsPage />,
        loader: async (match) => {
          return (
            await client.query({
              query: ConnectionsDocument,
              context: await getAccountContext(match.params.slug, client),
            })
          ).data;
        },
      },
    ],
  };
};
